import { fbt } from 'fbtee'

interface Props {
  description?: string
  note?: string
  placeholder?: boolean
}

/** Promoter copy for an artist-less set: its description, or an "unannounced" line, then its note. */
export function SetCopySection({ description, note, placeholder }: Props) {
  return (
    <div className="space-y-2">
      {description ? (
        <p className="text-sm text-muted-foreground leading-relaxed whitespace-pre-line">{description}</p>
      ) : placeholder ? (
        <p className="text-sm text-muted-foreground">
          {fbt(
            "This slot hasn't been announced yet.",
            'Set detail dialog line for a schedule slot whose artist the festival has not revealed',
          )}
        </p>
      ) : null}
      {note && <p className="text-xs text-muted-foreground">{note}</p>}
    </div>
  )
}
